// Convert merchant thresholds from the shop currency to the active presentment
// currency. Cart line totals and tag grouping are already calculated in Liquid.
class SplitShippingBars extends HTMLElement {
  connectedCallback() {
    const rate = Number(window.Shopify?.currency?.rate) || 1;
    const locale = window.Shopify?.locale || document.documentElement.lang || "en";
    const currency = window.Shopify?.currency?.active;
    if (!currency) return;

    const formatter = new Intl.NumberFormat(locale, { style: "currency", currency });
    this.querySelectorAll("[data-split-shipping-meter]").forEach((meter) => {
      const threshold = Math.round(Number(meter.dataset.threshold) * rate);
      const total = Number(meter.dataset.total);
      if (!Number.isFinite(threshold) || threshold <= 0 || !Number.isFinite(total)) return;

      const remaining = Math.max(0, threshold - total);
      const progress = Math.max(0, Math.min(100, Math.round(total / threshold * 100)));
      meter.classList.toggle("is-reached", remaining === 0);
      const label = meter.querySelector("[data-split-shipping-label]")?.textContent?.trim() || "Shipping";
      const indicator = meter.querySelector('[role="progressbar"]');
      indicator.setAttribute("aria-label", `${label} toward ${formatter.format(threshold / 100)}`);
      indicator.setAttribute("aria-valuenow", String(progress));
      indicator.setAttribute("aria-valuetext", remaining > 0
        ? `${formatter.format(remaining / 100)} away from ${label}`
        : `${label} reached`);
      const ringFill = meter.querySelector(".split-shipping-bars__fill");
      if (ringFill) {
        ringFill.style.strokeDasharray = `${progress} 100`;
        ringFill.style.strokeLinecap = progress > 0 ? "round" : "butt";
      } else {
        meter.querySelector(".stacked-shipping-bars__fill").style.width = `${progress}%`;
      }
      meter.querySelector("[data-split-shipping-remaining]").textContent = remaining > 0
        ? formatter.format(remaining / 100)
        : ringFill ? "✓" : "Unlocked";
      meter.querySelector("[data-split-shipping-state]").textContent = remaining > 0 ? ringFill ? "away" : "to go" : "";
    });
  }
}

if (!window.customElements.get("split-shipping-bars")) {
  window.customElements.define("split-shipping-bars", SplitShippingBars);
}
